import { Quest, QuestCategory } from '../../../types';

export const YOUNG_ATHLETE_QUESTS: Quest[] = [
  {
    id: 2200,
    category: QuestCategory.SkillBuilder,
    title: 'The Athlete\'s Warm-Up',
    questlineId: 'young-athlete',
    isQuestlineStart: true,
    description: 'Every athlete starts with a warm-up to prepare their body. Let\'s learn a simple routine to get your blood pumping and muscles ready.',
    details: 'Your routine: 20 jumping jacks, 10 high knees on each leg, and some gentle arm circles. This gets your body ready for action.',
    repeatDescription: 'Time to warm up! Get your body ready for today\'s training.',
    repeatDetails: 'Remember the routine: 20 jumping jacks, 10 high knees on each leg, and arm circles. A good warm-up prevents injuries and improves performance.'
  },
  {
    id: 2201,
    category: QuestCategory.SkillBuilder,
    title: 'Workout A: Foundation',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2200,
    description: 'You\'ve warmed up. Now for your first core workout. We\'ll focus on squats for leg strength and wall push-ups for your upper body.',
    details: 'After your warm-up, perform 2 sets of 10 squats and 2 sets of 10 wall push-ups. Focus on good form. Record your workout in your training log (notebook).',
    repeatDescription: 'Time for Workout A. Let\'s build that foundation.',
    repeatDetails: 'Complete your warm-up, then do 2 sets of 10 squats and 2 sets of 10 wall push-ups. Focus on making each one count. You\'re getting stronger every time!'
  },
  {
    id: 2202,
    category: QuestCategory.SkillBuilder,
    title: 'Workout B: Agility & Core',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2201,
    description: 'Let\'s add some new moves to your arsenal. Today we introduce agility drills and core-strengthening planks.',
    details: 'After your warm-up, perform 3 sets of 20-second fast feet drills, and 2 sets of 20-second planks. These build speed and stability.',
    repeatDescription: 'Time for Workout B. Focus on speed and stability today.',
    repeatDetails: 'Complete your warm-up, then do 3 sets of 20-second fast feet drills and 2 sets of 20-second planks. Keep that core tight!'
  },
  {
    id: 2203,
    category: QuestCategory.SkillBuilder,
    title: 'Workout C: The First Circuit',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2202,
    description: 'You know the moves. Now let\'s combine them into a circuit. This builds stamina.',
    details: 'After your warm-up, perform one round of this circuit: 10 squats, 10 wall push-ups, 20 seconds of fast feet, 20-second plank. Rest for 1 minute. That\'s one set.',
    repeatDescription: 'Challenge yourself with Workout C today.',
    repeatDetails: 'Warm up, then tackle the circuit: 10 squats, 10 wall push-ups, 20 seconds fast feet, 20-second plank. Try to complete two sets today!'
  },
  {
    id: 2204,
    category: QuestCategory.SkillBuilder,
    title: 'Level Up: Knee Push-Ups',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2203,
    description: 'Your wall push-ups are solid. It\'s time to take it to the floor with knee push-ups to build more strength.',
    details: 'Learn the form for knee push-ups. Try to do 2 sets of 5-8 repetitions. It\'s much harder, so focus on form over numbers. We\'ll add this to a new workout next.',
    repeatDescription: 'Let\'s work on your push-up strength with knee push-ups.',
    repeatDetails: 'Practice your knee push-ups today. Can you do 2 sets of 8? Or maybe even 10? Every rep builds power.'
  },
  {
    id: 2205,
    category: QuestCategory.SkillBuilder,
    title: 'Workout D: The Advanced Circuit',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2204,
    description: 'Let\'s build a new, tougher circuit with your upgraded push-up skill.',
    details: 'After your warm-up, try this circuit: 15 squats, 8 knee push-ups, 30 seconds of fast feet, 30-second plank. Rest for 1 minute. That\'s one set.',
    repeatDescription: 'Ready for the advanced circuit? Let\'s do Workout D.',
    repeatDetails: 'Warm up, then hit the advanced circuit: 15 squats, 8 knee push-ups, 30 seconds fast feet, 30-second plank. Aim for two complete sets. You\'ve got this!'
  },
  {
    id: 2206,
    category: QuestCategory.SkillBuilder,
    title: 'Level Up: Jump Squats',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2205,
    description: 'Time to add some explosive power. We\'ll turn your squats into jump squats.',
    details: 'After a good warm-up, practice jump squats. Squat down as normal, then explode upwards into a small jump. Land softly. Do 2 sets of 8 jumps. This is great for your climbing and running!',
    repeatDescription: 'Let\'s build explosive power with jump squats.',
    repeatDetails: 'Warm up, then practice your jump squats. Focus on an explosive jump and a soft landing. Can you do 2 sets of 10 today?'
  },
  {
    id: 2207,
    category: QuestCategory.SkillBuilder,
    title: 'Workout E: The Ultimate Circuit',
    questlineId: 'young-athlete',
    prerequisiteQuestId: 2206,
    description: 'This is it. The ultimate circuit combining all your skills. This is a big challenge.',
    details: 'Warm up well! Then, tackle this: 10 jump squats, 10 knee push-ups, 30 seconds of fast feet, 30-second plank. Rest 1-2 minutes. This is a tough workout for a young athlete!',
    repeatDescription: 'Feeling strong? It\'s time to challenge the Ultimate Circuit!',
    repeatDetails: 'Warm up well! Perform the ultimate circuit: 10 jump squats, 10 knee push-ups, 30 seconds fast feet, 30-second plank. Aim for two sets if you can. You\'re building real athletic ability!'
  }
];
